var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0412 0.396393H6.90472C6.66007 0.396393 6.46289 0.593572 6.46289 0.838221V15.4624C6.46289 15.707 6.66007 15.9042 6.90472 15.9042H17.0412C17.2859 15.9042 17.483 15.707 17.483 15.4624V0.838221C17.483 0.593572 17.2859 0.396393 17.0412 0.396393ZM16.5994 15.0206H7.34655V1.2764H16.5994V15.0206Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17751 1.2763C5.42216 1.2763 5.61934 1.07912 5.61934 0.834468C5.61934 0.589819 5.42216 0.392639 5.17751 0.392639H4.00173C3.75709 0.392639 3.55991 0.589819 3.55991 0.834468V15.4586C3.55991 15.7033 3.75709 15.9005 4.00173 15.9005H5.17751C5.42216 15.9005 5.61934 15.7033 5.61934 15.4586C5.61934 15.214 5.42216 15.0168 5.17751 15.0168H4.44356V1.2763H5.17751Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34392 1.2763C2.58857 1.2763 2.78575 1.07912 2.78575 0.834468C2.78575 0.589819 2.58857 0.392639 2.34392 0.392639H1.16815C0.923498 0.392639 0.726318 0.589819 0.726318 0.834468V15.4586C0.726318 15.7033 0.923498 15.9005 1.16815 15.9005H2.34392C2.58857 15.9005 2.78575 15.7033 2.78575 15.4586C2.78575 15.214 2.58857 15.0168 2.34392 15.0168H1.60998V1.2763H2.34392Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35113 4.18349H14.748C14.9927 4.18349 15.1898 3.98631 15.1898 3.74166C15.1898 3.49701 14.9927 3.29984 14.748 3.29984H9.35113C9.10648 3.29984 8.9093 3.49701 8.9093 3.74166C8.9093 3.98631 9.11013 4.18349 9.35113 4.18349Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35125 6.40911H14.7481C14.9928 6.40911 15.19 6.21193 15.19 5.96728C15.19 5.72263 14.9928 5.52545 14.7481 5.52545H9.35125C9.1066 5.52545 8.90942 5.72263 8.90942 5.96728C8.91308 6.21193 9.11026 6.40911 9.35125 6.40911Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35113 8.63097H14.748C14.9927 8.63097 15.1898 8.43379 15.1898 8.18914C15.1898 7.94449 14.9927 7.74731 14.748 7.74731H9.35113C9.10648 7.74731 8.9093 7.94449 8.9093 8.18914C8.9093 8.43379 9.11013 8.63097 9.35113 8.63097Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35113 10.8575H14.748C14.9927 10.8575 15.1898 10.6604 15.1898 10.4157C15.1898 10.1711 14.9927 9.97388 14.748 9.97388H9.35113C9.10648 9.97388 8.9093 10.1711 8.9093 10.4157C8.91295 10.6567 9.11013 10.8575 9.35113 10.8575Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35113 13.0813H11.9729C12.2175 13.0813 12.4147 12.8841 12.4147 12.6395C12.4147 12.3948 12.2175 12.1976 11.9729 12.1976H9.35113C9.10648 12.1976 8.9093 12.3948 8.9093 12.6395C8.9093 12.8841 9.11013 13.0813 9.35113 13.0813Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.cfb7305e.svg";
export { ForwardRef as ReactComponent };